import { ts } from "src/utils/translate";

export class QuestionData {

  public questionSteps;

  constructor() {
    this.questionSteps = [
      {
        key: "what_describes_your_role",
        question: ts("what_describes_your_role", "What best describes your role?"),
        options: [
          { label: ts("electrician", "Electrician"), value: "ELECTRICIAN" },
          { label: ts("electrical_engineer", "Electrical engineer"), value: "ELECTRICAL_ENGINEER" },
          { label: ts("diy_enthusiast", "DIY enthusiast"), value: "DIY_ENTHUSIAST" },
          { label: ts("other", "Other"), value: "OTHER" },
        ]
      },
      {
        key: "what_primary_area_of_interest",
        question: ts("what_primary_area_of_interest", "What's your primary area of interest?"),
        options: [
          { label: ts("home_automation_systems", "Home automation systems"), value: "HOME_AUTOMATION" },
          { label: ts("conventional_electrical_planning", "Conventional electrical planning"), value: "ELECTRICAL_PLANNING" },
          { label: ts("it_networks", "IT networks"), value: "IT_NETWORKS" },
        ]
      },
      {
        key: "what_main_challenge_currently_trying_to_solve",
        question: ts("what_main_challenge_currently_trying_to_solve", "What's the main challenge you're currently trying to solve?"),
        options: [
          { label: ts("creating_electrical_plans_faster", "Creating electrical plans faster"), value: "FASTER_PLANS" },
          { label: ts("generating_accurate_offers", "Generating accurate offers"), value: "ACCURATE_OFFERS" },
          { label: ts("automating_bill_of_materials", "Automating the Bill of Materials (BoM) creation"), value: "AUTOMATE_BOM" },
          { label: ts("managing_updates_across_project_versions", "Managing updates across project versions"), value: "MANAGE_UPDATES" },
          { label: ts("automating_loxone_planning", "Automating Loxone planning"), value: "LOXONE_PLANNING" },
          { label: ts("other", "Other"), value: "OTHER" },
        ]
      }
    ];
  }

}
